import { CustomPageBlock } from 'src/types';
import css from './text-block.module.scss';
import { ReactComponent as LinkArrow } from 'src/assets/services-arrow-btn-2.svg';
import RequestEmailModal from 'src/components/request-modal/request-email-modal';

export default function CustomBanner({ item }: Readonly<{ item: CustomPageBlock }>) {
  return (
    <div
      className={css.banner}
      style={{
        backgroundImage: `url(${item.imgUrl})`
      }}>
      <div className={css.container}>
        <div className={css.textGroup}>
          <h1>{item.title}</h1>
          <p>{item.description}</p>
          {item.showRequest && (
            <RequestEmailModal
              trigger={
                <button className={css.button}>
                  <p>{item.requestText}</p>
                  <LinkArrow className={css.arrow} />
                </button>
              }
            />
          )}
        </div>
      </div>
    </div>
  );
}
